import React, { useState } from 'react';

import { createNotification } from 'backend/IQuestion/Notification';

const NotificationCreateIQuestion = ({ callSuccess, isCreateMode }) => {
  const [resultMessage, setResultMessage] = useState(null);
  
  const [number, setNumber] = useState(0);

  const [titleEn, setTitleEn] = useState('');
  const [contentEn, setContentEn] = useState('');
  const [titleRu, setTitleRu] = useState('');
  const [contentRu, setContentRu] = useState('');
  const [titleUk, setTitleUk] = useState('');
  const [contentUk, setContentUk] = useState('');


  const clickOnCreateNotification = () => {
    createNotification(
      number,
      titleEn,
      titleRu,
      titleUk,
      contentEn,
      contentRu,
      contentUk,
    ).then(() => {
      setResultMessage('Push-нотификация создана! Теперь вы можете совершить рассылку.');
      setTitleEn('');
      setContentEn('');
      setTitleRu('');
      setContentRu('');
      setTitleUk('');
      setContentUk('');

      callSuccess();
    });
  };

  return (
    <>
    {resultMessage ? (
      <div className="row">
        <div className="col-md-12 text-center">
          <div className="alert alert-success">
            {resultMessage}
          </div>
        </div>
      </div>) : null}
      <div style={{display: isCreateMode}} id="idFormNotification">
        <form className="form-horizontal" role="form">
          <div className="row" style={{paddingTop: 20,}}>
            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-en">
                  Название EN 
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-en"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleEn} 
                    onChange={(event) => setTitleEn(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-en"> Текст EN </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-en" 
                    className="col-xs-12 col-sm-10"
                    value={contentEn}
                    onChange={(event) => setContentEn(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-ru">
                  Название RU 
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-ru"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleRu} 
                    onChange={(event) => setTitleRu(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-ru"> Текст RU </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-ru" 
                    className="col-xs-12 col-sm-10"
                    value={contentRu}
                    onChange={(event) => setContentRu(event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-4">
              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-title-uk">
                  Название UK
                </label>
                <div className="col-sm-9">
                  <input
                    id="form-title-uk"
                    type="text"
                    className="col-xs-12 col-sm-10"
                    value={titleUk} 
                    onChange={(event) => setTitleUk(event.target.value)} 
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-3 control-label no-padding-right" htmlFor="form-content-uk"> Текст UK </label>
                <div className="col-sm-9">
                  <textarea
                    id="form-content-uk" 
                    className="col-xs-12 col-sm-10"
                    value={contentUk}
                    onChange={(event) => setContentUk(event.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-5">
              <div className="form-group">
                <label className="col-sm-6 control-label no-padding-right" htmlFor="form-number">
                  Последовательность отправки
                </label>
                <div className="col-sm-6">
                  <input
                    id="form-number"
                    type="text"
                    className="col-xs-9 col-sm-9"
                    value={number} 
                    onChange={(event) => setNumber(event.target.value)} 
                  />
                </div>
              </div>
            </div>
            <div className="col-md-5 text-right">
              <button className="btn btn-info" type="button" onClick={() => clickOnCreateNotification()}>
                <i className="ace-icon fa fa-check bigger-110"></i>
                Сохранить
              </button>
            </div>
          </div>
        </form>
        <hr />
      </div>
    </>
  );
};

export default NotificationCreateIQuestion;
